import { UsersIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';

import { CustomerCard } from './customer-card';
import type { Customer } from './types';

interface Props {
  customers: Customer[];
  onSelect: (customerId: string) => void;
}

export function CustomersGrid({ customers, onSelect }: Props) {
  const { t } = useLanguage();

  if (customers.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-center border rounded-xl bg-card">
        <UsersIcon className="w-10 h-10 text-muted-foreground/40" />
        <p className="font-medium text-sm">{t.noCustomersFound}</p>
        <p className="text-xs text-muted-foreground">{t.noCustomersDescription}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {customers.map((customer, index) => (
        <CustomerCard
          key={customer.id}
          customer={customer}
          index={index}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
